import 'jquery';
import './slick.js';

const carouselSlider = () => {
  if (jQuery('*').hasClass('slider-videos-row')) {
    jQuery('.slider-videos-row').slick({
      dots: false,
      infinite: false,
      // speed: 200,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    jQuery('.arrow-next-video').on('click', function (e) {
      jQuery('.slider-videos-row').slick('slickNext');
    });
    jQuery('.arrow-prev-video').on('click', function (e) {
      jQuery('.slider-videos-row').slick('slickPrev');
    });
  }
};

export { carouselSlider };
